import React from 'react';
import Typography from '@mui/material/Typography';
import AvatarGroup from '@mui/material/AvatarGroup';
import Avatar from '@mui/material/Avatar';
import PrintIcon from '@mui/icons-material/Print';
import AlarmIcon from '@mui/icons-material/Alarm';
import ShareIcon from '@mui/icons-material/Share';
import { deepPurple, cyan, yellow, blueGrey, deepOrange } from '@mui/material/colors';

const styles = {
  boxClass: {
    // '& .MuiDataGrid-cell:hover': {
    //   color: 'primary.main',
    // },
    fontFamily: 'Quicksand'
  },
  textField: {
    input: {
      fontSize: '16px',
      fontFamily: 'Quicksand',
      lineHeight: '20px',
      fontWeight: '300',
      color: '#757687',
      padding: '8px 16px',
      borderRadius: '8px',
      height: '20px'
    },
    width: '100%'
  },
  multiline: {
    style: {
      fontSize: '16px',
      fontFamily: 'Quicksand',
      lineHeight: '20px',
      fontWeight: '300',
      color: '#757687',
      padding: '16px',
      borderRadius: '8px'
    },
  },
  selectField: {
    fontSize: '16px',
    fontFamily: 'Quicksand'
  },
  label: {
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '20px',
    textTransform: 'none',
    padding: '0 16px'
  },
  formLabel: {
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: '300',
    fontSize: '16px',
    lineHeight: '20px',
    textTransform: 'none'
  },
  dataGrid: {
    fontWeight: '500',
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontSize: '20px',
    lineHeight: '27px',
    color: '#757687'
  },
  showGrid: {
    fontSize: '20px',
    fontFamily: 'Quicksand',
    lineHeight: '27px',
    fontWeight: '500',
    color: '#757687'
  },
  showButton: {
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '25px',
    background: '#EBEEFF',
    borderRadius: '8px',
    padding: '8px 24px',
    color: '#18428F',
    boxShadow: 'none',
    textTransform: 'none'
  },
  saveButton: {
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '25px',
    background: '#EBEEFF',
    borderRadius: '8px',
    padding: '8px 24px',
    color: '#18428F',
    boxShadow: 'none',
    textTransform: 'none',
    border: 'none'
  },
  cancelButton: {
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '25px',
    background: '#EBEEFF',
    borderRadius: '8px',
    padding: '8px 24px',
    color: '#18428F',
    boxShadow: 'none',
    textTransform: 'none',
    border: 'none'
  },
  gridText: {
    input: {
      fontSize: 12
    },
    width: '100%'
  },
  gridSaveBtn: {
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '20px',
    lineHeight: '27px',
    backgroundColor: 'transparent',
    padding: '8px 24px',
    textTransform: 'none',
    color: '#18428F'
  },
  gridUpdateBtn: {
    color: '#A9AABC',
    backgroundColor: 'transparent',
    fontFamily: 'Quicksand'
  },
  gridDeleteBtn: {
    color: '#A9AABC',
    backgroundColor: 'transparent',
    fontFamily: 'Quicksand'
  },
  tabHeader: {
    fontSize: '20px',
    '@media (max-width: 768px)': {
      fontSize: '14px',
    },
    '@media (max-width: 480px)': {
      fontSize: '12px',
    },
    lineHeight: '27px',
    fontWeight: '500',
    fontFamily: 'Quicksand',
    textTransform: 'none'
  },
  alert: {
    fontSize: '40px',
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '50px',
    textAlign: 'center',
    color: '#18428F',
    marginBottom: '16px'
  },
  alertDescription: {
    fontSize: '24px',
    fontFamily: 'Quicksand',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '30px',
    textAlign: 'center',
    color: '#A9AABC'
  },
  showReportGrid: {
    fontSize: '14px',
    fontFamily: 'Quicksand',
    lineHeight: '27px',
    fontWeight: '500',
    color: '#757687',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    textAlign: 'center'
  }
};

const colors = {
  0: {
    color: deepPurple[300]
  },
  1: {
    color: deepOrange[500]
  },
  2: {
    color: cyan[500]
  },
  3: {
    color: yellow[500]
  },
  4: {
    color: blueGrey[500]
  }
};

export const styleForHeader = (value) => {
  return (
    <Typography variant="h6" sx={{
      fontWeight: '500',
      fontFamily: 'Quicksand',
      fontStyle: 'normal',
      fontSize: '20px',
      lineHeight: '27px',
      color: '#18428F'
    }}>
      {value}
    </Typography>
  )
}

export const styleForIcon = (value) => {
  return (
    <div>
      <PrintIcon sx={styles.textField} />
      <AlarmIcon sx={styles.textField} />
      <ShareIcon sx={styles.textField} />
    </div>
  )
}

export const styleForAvatar = (signerInfo) => {
  return (
    <AvatarGroup className="customAvatarGroup">
      {signerInfo &&
        signerInfo.map((signer, index) => (
          <Avatar className="customAvatar" key={index} sx={{ bgcolor: setColor(index), alignSelf: 'center' }} >
            {signer.name.split(' ')[0].charAt(0).toUpperCase() + (signer.name.split(' ')[1] ? signer.name.split(' ')[1].charAt(0).toUpperCase() : "")}
          </Avatar>
        ))
      }
    </AvatarGroup>
  )
}

export const styleForReportHeader = (value) => {
  return (
    <Typography
      variant="h6"
      sx={{
        fontWeight: '500',
        fontFamily: 'Quicksand',
        fontStyle: 'normal',
        fontSize: '15px',
        lineHeight: '18px',
        color: '#18428F',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        textAlign: 'center'
      }}>
      {value}
    </Typography>
  )
}

function setColor(index) {
  let modIndex = index % 5;
  let color = colors[modIndex].color;
  return color
}

export default styles;

